import React from 'react';

const CoreIcon = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.333008 3.66683H3.66634V0.333496H0.333008V3.66683ZM5.33301 13.6668H8.66634V10.3335H5.33301V13.6668ZM0.333008 13.6668H3.66634V10.3335H0.333008V13.6668ZM0.333008 8.66683H3.66634V5.3335H0.333008V8.66683ZM5.33301 8.66683H8.66634V5.3335H5.33301V8.66683ZM10.333 0.333496V3.66683H13.6663V0.333496H10.333ZM5.33301 3.66683H8.66634V0.333496H5.33301V3.66683ZM10.333 8.66683H13.6663V5.3335H10.333V8.66683ZM10.333 13.6668H13.6663V10.3335H10.333V13.6668Z" fill="currentColor"/>
    </svg>
  )
}

export default CoreIcon;